"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0; // A queue of functions that wait to run until the tab-ads
// config is set. After the config is set, any commands
// are immediately executed.

var runQueue = false;
var cmdStorage = [];

function queue(cmd) {
  if (runQueue) {
    cmd();
  } else {
    cmdStorage.push(cmd);
  }
}

queue.runQueue = function (shouldRunQueue) {
  runQueue = shouldRunQueue;

  if (runQueue) {
    cmdStorage.forEach(function (cmd) {
      cmd();
    });
    cmdStorage = [];
  }
};

var _default = queue;
exports.default = _default;